import type { ValidationConfig } from '../validationEngine/types';

export const incentiveValidationConfig: ValidationConfig = {
    name: {
        rules: [
            {
                type: 'REQUIRED',
                flow: 'save',
                messages: 'Required'
            }
        ]
    },
    amount: {
        rules: [
            {
                type: 'REQUIRED',
                flow: 'save',
                messages: 'Required'
            }
        ]
    }
};
